import React from "react";
import PropTypes from "prop-types";
import { LucideIcon } from "lucide-react"; // Lucide icons are imported dynamically
import classNames from "classnames";

/**
 * Reusable Button Icon Component using Lucide Icons
 */
const ButtonIcon = ({ icon: Icon, size, color, className, ...props }) => {
  return (
    <Icon
      size={size}
      color={color}
      className={classNames("button-icon", className)}
      {...props}
    />
  );
};

ButtonIcon.propTypes = {
  icon: PropTypes.elementType.isRequired, // Pass Lucide icon component
  size: PropTypes.number,
  color: PropTypes.string,
  className: PropTypes.string,
};

ButtonIcon.defaultProps = {
  size: 20, // Default size
  color: "currentColor", // Inherits text color
  className: "",
};

export default ButtonIcon;
